module.exports = "<div class=\"overlay\">\n\n    <div class=\"lds-facebook\"><div>\n</div>"